import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import CustomerManagement from "@/pages/CustomerManagement";

interface CustomerQuickViewDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  customerId: string | null;
  customerName?: string;
}

export const CustomerQuickViewDialog = ({
  open,
  onOpenChange,
  customerId,
  customerName,
}: CustomerQuickViewDialogProps) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  // Prevent background scroll while the quick view is open.
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  // We intentionally reuse the exact CustomerManagement UI (modal mode) to achieve 1:1 parity.
  if (!open || !isMounted) return null;

  return createPortal(
    <div className="fixed inset-0 z-50">
      <CustomerManagement
        customerId={customerId ?? undefined}
        onClose={() => onOpenChange(false)}
      />
    </div>,
    document.body
  );
};
